import { render, staticRenderFns } from "./DataStory.vue?vue&type=template&id=7c11fcde&scoped=true&"
import script from "./DataStory.vue?vue&type=script&lang=js&"
export * from "./DataStory.vue?vue&type=script&lang=js&"
import style0 from "./DataStory.vue?vue&type=style&index=0&id=7c11fcde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c11fcde",
  null
  
)

export default component.exports